










































































import AbpBase from "@/lib/abpbase";
import { Component,Watch,Prop } from "vue-property-decorator";
import PdEducationPlanPlay from "./pdPreviousEducationPlay.vue";
import PdPatientEducationPlanAssess from "./pdPatientEducationPlanAssess.vue";
import { getPlanStepList,getPlanStepDetailList} from "@/api/pdEducationPlan/pdPatientEducationPlan";
@Component({
  components: {
    PdEducationPlanPlay,
    PdPatientEducationPlanAssess
  }
})
export default class PdPatientPatientEducationPlanStep extends AbpBase {
  @Prop() pdPatientEducationPlan: any;
  split1 = 0.5;
  loading: boolean = false;
  detailLoading: boolean = false;
  currentPlan: any = {};
  currentPlanDetail: any = {};
  showEducationPlanAssess: boolean = false;
  showPlanDetailPlay: boolean = false;
  response: any = {};
  detailResponse: any = {};
  PatientEducationPlan: any = {};
  payload = {
    PD_Patient_Plan_ID:0,
    SkipCount: 1,
    MaxResultCount: 10,
  };
  detailPayload = {
    PD_Patient_Step_ID: 0,
    SkipCount: 1,
    MaxResultCount: 10,
  };
  columns = [
    {
      title: "步骤名称",
      key: "planStepName",
      minWidth: 150
    },
    {
      title: "步骤说明",
      key: "planStepDescription",
      minWidth: 180,
    }
  ];
  detailColumns = [
    {
      title: "材料名称",
      key: "knowName",
      minWidth: 120
    },
    {
      title: "说明",
      key: "knowText",
      minWidth: 200
    },
    {
      title:"完成时间",
      key: "finish_Time",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.finish_Time));
      }
    },    
    {
      title:"完成人",
      key: "finishUserName",
      minWidth: 80,
    },
    {
      title: "操作",
      key: "",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "info", icon: "ios-play", size: "small"  },
              domProps: {
                title: "执行宣教"
              },
            on: {
              click: () => {
                this.handlePlanDetailPlay(p.row);
              }
            }
          })
        ]);
      }
    }
  ];

  @Watch("pdPatientEducationPlan", { immediate: false, deep: true })
  onGetPatientEducationPlanStep() {
    if (this.pdPatientEducationPlan) {
      this.PatientEducationPlan = this.pdPatientEducationPlan;
    }
    this.detailResponse={};
    this.getPlanList();
  }

  handlePlanDetailPlay(row: any) {
    this.currentPlanDetail = Object.assign({}, row);
    console.log(this.currentPlanDetail);
    this.showPlanDetailPlay = true;
  }

  handlePlanPageChange(val: any) {
    this.payload.SkipCount = val;
    this.getPlanList();
  }

  handlePlanDetailPageChange(val: any) {
    this.detailPayload.SkipCount = val;
    this.getPlanDetailList();
  }


  handlePlanClick(row: any, index: any) {
    this.currentPlan = row;
    this.getPlanDetailList();
  }

  async getPlanList() {
    this.loading = true;
    this.payload.PD_Patient_Plan_ID = this.PatientEducationPlan.id;
    let res = await getPlanStepList(this.payload);
    this.response = res.data;
    this.loading = false;
  }

  async getPlanDetailList() {
    if (this.currentPlan.id) {
      this.detailLoading = true;
      this.detailPayload.PD_Patient_Step_ID = this.currentPlan.id;
      let res = await getPlanStepDetailList(this.detailPayload);
      this.detailResponse = res.data;
      this.detailLoading = false;
    }
  }

  //宣教完成
  onUpdatePlanDetailOk() {
    this.loading = true;
    this.$refs.PdEducationPlanPlay.submit().then(res => {
      if (res) {
        this.showPlanDetailPlay = false;
        this.getPlanDetailList();
      }
    });
    this.loading = false;
  }

  //宣教评估
  EducationPlanAssessAddOk() {
    this.loading = true;
    this.$refs.PdPatientEducationPlanAssess.submit().then(res => {
      if (res) {
        this.showEducationPlanAssess = false;
      }
    });
    this.loading = false;
  }
  onAddPatientEducationPlanAssess(){
    this.showEducationPlanAssess=true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationPlan/pdPatientEducationPlanStep.vue